import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
// 导入全局配置文件
import './plugins'
// 全局API
import API from '@/api'
// 登录检测
import '@/permission'
import ElementUI from 'element-ui'
// 全球化
import i18n from '@/i18n'
// 全局自定义样式
import '@/css/global.scss'
import '@/css/revision.css'
import '@/css/font.scss'
import * as echarts from 'echarts'
// import '@/styles/element-variables.scss'
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$API = API
Vue.config.productionTip = false
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
